import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const SpaceMetadataQuery: GraphQLTaggedNode = graphql`
	query SpaceMetadataQuery($id: Long!) {
		spaces(spaceId: $id) {
			nodes {
				homepage {
					id
				}
			}
		}
	}
`;
